'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var sizes = {
  'lg': 19,
  '2x': 28,
  '3x': 42,
  '4x': 56,
  '5x': 70
};
var baseStyle = {
  position: 'relative',
  userSelect: 'none',
  textAlignVertical: 'text-bottom',
  display: 'inline-block'
};

var getContent = function getContent(fillContent, lightContent, regularContent) {
  var weight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'regular';

  switch (weight) {
    case 'regular':
      return regularContent;

    case 'light':
      return lightContent;

    case 'fill':
      return fillContent;
  }

  return regularContent;
};

var createIconComponent = function createIconComponent(_ref) {
  var fillContent = _ref.fillContent,
      lightContent = _ref.lightContent,
      regularContent = _ref.regularContent,
      height = _ref.height,
      width = _ref.width,
      viewBox = _ref.viewBox;
  return function (props) {
    return (0, _react.createElement)('svg', _extends({}, props, {
      style: _extends({}, baseStyle, {
        height: sizes[props.size] || 14 + 'px',
        fill: props.color || 'currentColor'
      }, props.style),
      viewBox: viewBox || '0 0 ' + width + ' ' + height
    }), getContent(fillContent, lightContent, regularContent, props.weight));
  };
};

exports.default = createIconComponent;